"use client"

import { useState } from "react"
import { ChevronDown, ChevronUp } from "lucide-react"

const MobileCollapsibleService = ({ service }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => setIsOpen(!isOpen)

  return (
    <div className="mobile-service-item">
      <button className="mobile-service-header" onClick={toggleOpen}>
        <div className="mobile-service-icon">{service.icon}</div>
        <h3 className="mobile-service-title">{service.title}</h3>
        {isOpen ? <ChevronUp className="mobile-chevron" /> : <ChevronDown className="mobile-chevron" />}
      </button>
      {isOpen && (
        <div className="mobile-service-content">
          <h1 className="mobile-main-title">{service.description}</h1>
          <div className="mobile-main-description">
            {typeof service.content === "string" ? <p>{service.content}</p> : service.content}
          </div>
          {service.image && (
            <div className={`mobile-service-image-container ${service.imageClass}`}>
              <img src={service.image || "/placeholder.svg"} alt={service.title} className="mobile-service-image" />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default MobileCollapsibleService
